// extracted by mini-css-extract-plugin
module.exports = {"landing":"mV7vG1XSBS-Cum3bQdfP1w==","textarea":"gxhu2tc5o8j-aDmLAf0ZhA=="};